import { ref, watch } from 'vue'

/**
 * Persist a layout-mode choice (e.g. "table" | "cards" | "compact") per-page.
 * Ported from the Samui design bundle useLayoutMode hook.
 */
export function useLayoutMode(key, modes, initial) {
  const storeKey = `samui_layout_${key}`
  const saved = typeof localStorage !== 'undefined' ? localStorage.getItem(storeKey) : null
  const valid = saved && modes.some((m) => m.v === saved)
  const mode = ref(valid ? saved : initial)
  watch(mode, (v) => {
    try { localStorage.setItem(storeKey, v) } catch {}
  })
  return mode
}
